export const t = {
  es: {
    // Header
    role: 'Software Engineer Full Stack',
    stack: 'React · Node.js · IA / LLMs · Mercado Pago',

    // About
    aboutTitle: 'Sobre mí',
    aboutP1: 'Software Engineer Full Stack con <strong>4 años de experiencia</strong> construyendo productos web end-to-end: desde landings y eCommerce hasta marketplaces con pagos integrados y aplicaciones con <strong>inteligencia artificial</strong> en producción.',
    aboutP2: 'Trabajo con clientes en industrias muy diversas (salud, propiedades, retail, hosting, educación, entretenimiento, impresión 3D) y además mantengo productos propios en producción como',
    and: 'y',
    aboutP3: 'Stack principal: <strong>React, Node.js, Firebase, WordPress y Mercado Pago</strong>, más integración de modelos de lenguaje (Claude) con salidas estructuradas y control de costos. Desarrollo todos los días con agentes de IA. Trabajo remoto en todo Argentina y presencial en Luján y zona oeste.',

    // Skills
    skillsTitle: 'Stack técnico',
    groups: [
      { label: 'IA / LLMs', items: ['API de Claude (Anthropic)', 'Prompts y salidas estructuradas (JSON)', 'Agentes y uso de herramientas', 'MCP', 'Claude Code'] },
      { label: 'Frontend', items: ['React', 'TypeScript', 'JavaScript', 'Next.js', 'Tailwind', 'SASS', 'Three.js', 'WebXR', 'Storybook', 'Vue.js'] },
      { label: 'Backend & datos', items: ['Node.js', 'Express', 'PHP', 'Firebase', 'PostgreSQL (Supabase)', 'MongoDB', 'SQL', 'Cloud Functions', 'REST APIs'] },
      { label: 'CMS & pagos', items: ['WordPress', 'Mercado Pago', 'Webhooks', 'Nextend Social Login'] },
      { label: 'Tooling & deploy', items: ['Git', 'GitHub', 'Docker', 'Render', 'Vercel', 'Vite', 'Figma', 'Postman', 'FlutterFlow'] },
      { label: 'Idiomas', items: ['Español (Nativo)', 'Inglés C1'] },
    ],

    // Work Experience
    workTitle: 'Experiencia de trabajo',
    techLabel: 'Tecnologías',
    experiences: [
      {
        company: 'Alia Oficios',
        role: 'Desarrollador Frontend (equipo)',
        period: '2026',
        description: 'Plataforma en producción que conecta personas con profesionales de oficios de su zona (perfiles, reseñas, solicitudes y seguimiento). Diseñé e implementé el sistema de diseño (tokens y componentes reutilizables) y el rediseño completo de la interfaz, y configuré el entorno con Docker.',
        tecnologias: 'Next.js, TypeScript, Tailwind, Supabase, Docker',
      },
      {
        company: 'La Guía del Ocio',
        role: 'Desarrollador WordPress',
        period: '2026 - presente',
        description: 'Desarrollo del Club del Ocio: sistema de membresías con login via Google OAuth, control de acceso por roles, redirección automática post-login y protección de páginas para usuarios no registrados. Integración de Nextend Social Login con WordPress.',
        tecnologias: 'WordPress, PHP, Google OAuth, MySQL',
      },
      {
        company: 'STL Premium',
        role: 'Desarrollador Full Stack',
        period: '2026 - presente',
        description: 'Desarrollo completo de marketplace de modelos 3D para impresión: arquitectura React + Firebase con autenticación, panel de administración, previsualización 3D interactiva de productos en tiempo real, integración de Mercado Pago con webhooks para liberación automática de archivos post-compra, y dominio personalizado en producción.',
        tecnologias: 'React, Firebase, Three.js, Redux, Vite, Mercado Pago API',
      },
      {
        company: 'Cabañas del Arroyo',
        role: 'Desarrollador Web',
        period: '2026 - 2026',
        description: 'Rediseño completo del sitio web: desarrollo de landing page con HTML, CSS y JavaScript vanilla, galería de fotos responsive, formulario de contacto con PHP, integración de WhatsApp y redes sociales, y configuración de certificado SSL.',
        tecnologias: 'HTML, CSS, JavaScript, PHP',
      },
      {
        company: 'Nuxon',
        role: 'Desarrollador',
        period: '2025 - 2025',
        description: 'Posicionamiento SEO, Desarrollo de plataforma SaaS y sistema de fidelización de clientes.',
        tecnologias: 'FlutterFlow, Firebase',
      },
      {
        company: 'Doucampus',
        role: 'Desarrollador Fullstack',
        period: '2025 - 2025',
        description: 'Desarrollo de sistema de gestión de inscripciones mediante formularios, firma digital, integración API mercadopago, dashboard para visualización de inscripciones vigentes y Cloud Functions para contador automático de inscriptos.',
        tecnologias: 'React, Node, Firebase, Tailwind',
      },
      {
        company: 'Di Martino Propiedades',
        role: 'Desarrollador Fullstack',
        period: '2024 - 2024',
        description: 'Integración de API de base de datos a CRM, creación de componentes con Storybook, desarrollo de calculadora de alquileres.',
        tecnologias: 'React, TypeScript, Tailwind, Storybook, Node',
      },
      {
        company: 'Bodnes',
        role: 'Desarrollador Fullstack',
        period: '2025 - 2025',
        description: 'Rebranding, implementación de Mercado Pago, compra sin registro.',
        tecnologias: 'React, Firebase, Redux, SASS',
      },
      {
        company: 'Vapesmoker',
        role: 'Desarrollador Fullstack',
        period: '2024 - 2024',
        description: 'Desarrollo de negocio online con panel de administrador para la carga de productos.',
        tecnologias: 'React, Firebase, Redux, SASS',
      },
      {
        company: 'Desarrollador independiente',
        role: 'Desarrollador Fullstack',
        period: '2023 - 2023',
        description: 'Desarrollo de portafolio, sistema de inventario, Custom Chart.',
        tecnologias: 'React, Node, TypeScript, Tailwind',
      },
      {
        company: 'Caja de Psicólogos de la Provincia de Buenos Aires',
        role: 'Desarrollador Fullstack',
        period: '2022 - 2022',
        description: 'Desarrollo de sistema de turnos.',
        tecnologias: 'Vue JS, Node',
      },
    ],

    // Projects
    ownProductsTitle: 'Productos propios',
    ownProductsSubtitle: 'Plataformas que diseñé, desarrollé y mantengo en producción.',
    clientProjectsTitle: 'Proyectos para clientes',
    clientProjectsSubtitle: 'Una selección de trabajos en distintas industrias.',
    ownProducts: [
      {
        title: 'Narra VR',
        description: 'Contás un lugar (con la voz o escribiendo) y aparece pintado a tu alrededor en 360°, en la compu, el celular o un visor de realidad virtual. Un modelo de lenguaje (Claude) interpreta la historia y devuelve la receta del paisaje en JSON; incluye control de costos, límites de uso, modo aula y panel de métricas.',
        tech: ['React', 'Three.js', 'WebXR', 'Node.js', 'Claude API', 'Supabase', 'Docker'],
        link: 'https://vr.prospera.com.ar/',
      },
      {
        title: 'STL Premium',
        description: 'Marketplace de modelos 3D con previsualización interactiva, selector de color de filamento y descarga de archivos post-compra.',
        tech: ['React', 'Firebase', 'Three.js', 'Redux', 'Mercado Pago'],
        link: 'https://stlpremium.com/',
      },
      {
        title: 'Custom Radar Chart',
        description: 'Generador online de radar / spider charts. Sin registro, exportación como imagen, totalmente personalizable.',
        tech: ['React', 'Canvas API', 'Tailwind'],
        link: 'https://customradarchart.com/',
      },
      {
        title: 'Etimoteca',
        description: 'Enciclopedia navegable de etimologías comparadas entre idiomas: raíz, morfología, sentido literal vs. lexicalizado y referencias cruzadas. Más de 430 palabras organizadas en carpetas temáticas.',
        tech: ['React', 'Vite', 'Vercel'],
        link: 'https://etimoteca.com/',
      },
    ],
    clientProjects: [
      { title: 'Alia Oficios', description: 'Red de profesionales de oficios por zona, con perfiles, reseñas y solicitudes. Sistema de diseño y rediseño de la interfaz.', tech: ['Next.js', 'TypeScript', 'Supabase'], link: 'https://aliaoficios.com/' },
      { title: 'Club del Ocio · La Guía del Ocio', description: 'Sistema de membresías en WordPress con login social y control de roles.', tech: ['WordPress', 'PHP', 'Google OAuth'], link: 'https://clubdelocio.com.ar/' },
      { title: 'Cabañas del Arroyo', description: 'Sitio web con galería responsive, formulario de contacto y SSL.', tech: ['HTML', 'CSS', 'JavaScript', 'PHP'], link: 'https://www.cabaniasdelarroyo.com.ar/' },
      { title: 'Bodnes', description: 'eCommerce con rebranding e integración de Mercado Pago.', tech: ['React', 'Firebase', 'Redux', 'SASS'], link: 'https://www.bodnes.com/' },
      { title: 'Doucampus', description: 'Gestión de inscripciones online con firma digital y pagos.', tech: ['React', 'Node', 'Tailwind'], link: 'https://www.doucampus.com/' },
      { title: 'Di Martino Propiedades', description: 'Plataforma de compra-venta y alquiler de inmuebles, con CRM.', tech: ['TypeScript', 'React', 'Storybook'], link: 'https://www.dimartinoprop.com.ar/' },
      { title: 'Nuxon', description: 'Sistemas SaaS desarrollados con FlutterFlow.', tech: ['FlutterFlow', 'Firebase'], link: 'https://nuxon.com.ar/' },
      { title: 'Vapesmoker', description: 'eCommerce con panel de administrador para carga de productos.', tech: ['React', 'Firebase', 'Redux'], link: 'https://www.vapesmoker.xyz/' },
      { title: 'Caja de Psicólogos PBA', description: 'Sistema de gestión de turnos online.', tech: ['Vue', 'Node'], link: 'https://www.cajapsipba.org.ar/' },
    ],
  },

  en: {
    // Header
    role: 'Full Stack Software Engineer',
    stack: 'React · Node.js · AI / LLMs · Mercado Pago',

    // About
    aboutTitle: 'About me',
    aboutP1: 'Full Stack Software Engineer with <strong>4 years of experience</strong> building end-to-end web products: from landing pages and eCommerce to marketplaces with integrated payments and <strong>AI-powered</strong> applications in production.',
    aboutP2: 'I work with clients across diverse industries (healthcare, real estate, retail, hosting, education, entertainment, 3D printing) and also maintain my own products in production such as',
    and: 'and',
    aboutP3: 'Main stack: <strong>React, Node.js, Firebase, WordPress and Mercado Pago</strong>, plus language model integration (Claude) with structured outputs and cost control. I build with AI coding agents every day. I work remotely across Argentina and on-site in Luján and the western suburbs of Buenos Aires.',

    // Skills
    skillsTitle: 'Tech stack',
    groups: [
      { label: 'AI / LLMs', items: ['Claude API (Anthropic)', 'Prompts and structured outputs (JSON)', 'Agents and tool use', 'MCP', 'Claude Code'] },
      { label: 'Frontend', items: ['React', 'TypeScript', 'JavaScript', 'Next.js', 'Tailwind', 'SASS', 'Three.js', 'WebXR', 'Storybook', 'Vue.js'] },
      { label: 'Backend & data', items: ['Node.js', 'Express', 'PHP', 'Firebase', 'PostgreSQL (Supabase)', 'MongoDB', 'SQL', 'Cloud Functions', 'REST APIs'] },
      { label: 'CMS & payments', items: ['WordPress', 'Mercado Pago', 'Webhooks', 'Nextend Social Login'] },
      { label: 'Tooling & deploy', items: ['Git', 'GitHub', 'Docker', 'Render', 'Vercel', 'Vite', 'Figma', 'Postman', 'FlutterFlow'] },
      { label: 'Languages', items: ['Spanish (Native)', 'English C1'] },
    ],

    // Work Experience
    workTitle: 'Work Experience',
    techLabel: 'Technologies',
    experiences: [
      {
        company: 'Alia Oficios',
        role: 'Frontend Developer (team)',
        period: '2026',
        description: 'Production platform connecting people with local trade professionals (profiles, reviews, requests and follow-up). I designed and built the design system (tokens and reusable components) and the full UI redesign, and set up the Docker environment.',
        tecnologias: 'Next.js, TypeScript, Tailwind, Supabase, Docker',
      },
      {
        company: 'La Guía del Ocio',
        role: 'WordPress Developer',
        period: '2026 - present',
        description: 'Development of Club del Ocio: membership system with Google OAuth login, role-based access control, automatic post-login redirection and page protection for unregistered users. Integration of Nextend Social Login with WordPress.',
        tecnologias: 'WordPress, PHP, Google OAuth, MySQL',
      },
      {
        company: 'STL Premium',
        role: 'Full Stack Developer',
        period: '2026 - present',
        description: 'Full development of a 3D model marketplace for printing: React + Firebase architecture with authentication, admin panel, real-time interactive 3D product preview, Mercado Pago integration with webhooks for automatic file release after purchase, and custom domain in production.',
        tecnologias: 'React, Firebase, Three.js, Redux, Vite, Mercado Pago API',
      },
      {
        company: 'Cabañas del Arroyo',
        role: 'Web Developer',
        period: '2026 - 2026',
        description: 'Complete website redesign: landing page with HTML, CSS and vanilla JavaScript, responsive photo gallery, PHP contact form, WhatsApp and social media integration, and SSL certificate setup.',
        tecnologias: 'HTML, CSS, JavaScript, PHP',
      },
      {
        company: 'Nuxon',
        role: 'Developer',
        period: '2025 - 2025',
        description: 'SEO positioning, development of SaaS platform and customer loyalty system.',
        tecnologias: 'FlutterFlow, Firebase',
      },
      {
        company: 'Doucampus',
        role: 'Fullstack Developer',
        period: '2025 - 2025',
        description: 'Development of an enrollment management system with forms, digital signature, Mercado Pago API integration, dashboard for viewing active enrollments, and Cloud Functions for automatic enrollment counter.',
        tecnologias: 'React, Node, Firebase, Tailwind',
      },
      {
        company: 'Di Martino Propiedades',
        role: 'Fullstack Developer',
        period: '2024 - 2024',
        description: 'Database API integration into CRM, component creation with Storybook, development of rental price calculator.',
        tecnologias: 'React, TypeScript, Tailwind, Storybook, Node',
      },
      {
        company: 'Bodnes',
        role: 'Fullstack Developer',
        period: '2025 - 2025',
        description: 'Rebranding, Mercado Pago implementation, guest checkout.',
        tecnologias: 'React, Firebase, Redux, SASS',
      },
      {
        company: 'Vapesmoker',
        role: 'Fullstack Developer',
        period: '2024 - 2024',
        description: 'Development of an online store with admin panel for product management.',
        tecnologias: 'React, Firebase, Redux, SASS',
      },
      {
        company: 'Independent Developer',
        role: 'Fullstack Developer',
        period: '2023 - 2023',
        description: 'Development of portfolio, inventory system, and Custom Chart.',
        tecnologias: 'React, Node, TypeScript, Tailwind',
      },
      {
        company: 'Caja de Psicólogos de la Provincia de Buenos Aires',
        role: 'Fullstack Developer',
        period: '2022 - 2022',
        description: 'Development of an appointment scheduling system.',
        tecnologias: 'Vue JS, Node',
      },
    ],

    // Projects
    ownProductsTitle: 'Own Products',
    ownProductsSubtitle: 'Platforms I designed, built and maintain in production.',
    clientProjectsTitle: 'Client Projects',
    clientProjectsSubtitle: 'A selection of work across different industries.',
    ownProducts: [
      {
        title: 'Narra VR',
        description: 'Describe a place (by voice or text) and it appears painted around you in 360°, on desktop, mobile or a VR headset. A language model (Claude) interprets the story and returns the scene recipe as JSON; includes cost control, usage limits, a classroom mode and a metrics dashboard.',
        tech: ['React', 'Three.js', 'WebXR', 'Node.js', 'Claude API', 'Supabase', 'Docker'],
        link: 'https://vr.prospera.com.ar/',
      },
      {
        title: 'STL Premium',
        description: '3D model marketplace with interactive preview, filament color selector and file download after purchase.',
        tech: ['React', 'Firebase', 'Three.js', 'Redux', 'Mercado Pago'],
        link: 'https://stlpremium.com/',
      },
      {
        title: 'Custom Radar Chart',
        description: 'Online radar / spider chart generator. No sign-up required, export as image, fully customizable.',
        tech: ['React', 'Canvas API', 'Tailwind'],
        link: 'https://customradarchart.com/',
      },
      {
        title: 'Etimoteca',
        description: 'Navigable encyclopedia of comparative etymologies across languages: root, morphology, literal vs. lexicalized meaning and cross-references. 430+ words organized into thematic folders.',
        tech: ['React', 'Vite', 'Vercel'],
        link: 'https://etimoteca.com/',
      },
    ],
    clientProjects: [
      { title: 'Alia Oficios', description: 'Network of local trade professionals with profiles, reviews and requests. Design system and UI redesign.', tech: ['Next.js', 'TypeScript', 'Supabase'], link: 'https://aliaoficios.com/' },
      { title: 'Club del Ocio · La Guía del Ocio', description: 'WordPress membership system with social login and role-based access.', tech: ['WordPress', 'PHP', 'Google OAuth'], link: 'https://clubdelocio.com.ar/' },
      { title: 'Cabañas del Arroyo', description: 'Website with responsive gallery, contact form and SSL.', tech: ['HTML', 'CSS', 'JavaScript', 'PHP'], link: 'https://www.cabaniasdelarroyo.com.ar/' },
      { title: 'Bodnes', description: 'eCommerce with rebranding and Mercado Pago integration.', tech: ['React', 'Firebase', 'Redux', 'SASS'], link: 'https://www.bodnes.com/' },
      { title: 'Doucampus', description: 'Online enrollment management with digital signature and payments.', tech: ['React', 'Node', 'Tailwind'], link: 'https://www.doucampus.com/' },
      { title: 'Di Martino Propiedades', description: 'Real estate buy/sell and rental platform with CRM.', tech: ['TypeScript', 'React', 'Storybook'], link: 'https://www.dimartinoprop.com.ar/' },
      { title: 'Nuxon', description: 'SaaS systems built with FlutterFlow.', tech: ['FlutterFlow', 'Firebase'], link: 'https://nuxon.com.ar/' },
      { title: 'Vapesmoker', description: 'eCommerce with admin panel for product management.', tech: ['React', 'Firebase', 'Redux'], link: 'https://www.vapesmoker.xyz/' },
      { title: 'Caja de Psicólogos PBA', description: 'Online appointment scheduling system.', tech: ['Vue', 'Node'], link: 'https://www.cajapsipba.org.ar/' },
    ],
  },
};
